const main_state = {
  login: false,
  loader: false,
  info: false,
  histories: false,
  on_animation: false,
  shoot_animation: false,
  skip_animation: false,
  google_analytics_consent: {
    ad_storage: 1,
    analytics_storage: 1,
    ad_user_data: 1,
    ad_personalization: 1,
  },
}

const main = (state = main_state, action) => {
  switch (action.type) {
    case "PUT_DATA":
      return { ...state, [action.key]: action.data }
    case "TOGGLE_LOADER":
      return { ...state, loader: action.data }

    default:
      return state
  }
}

export default main
